/**
 * Frontend build information, injected at build time by Vite's `define`
 * (see vite.config.ts). The values come from CF_PAGES_COMMIT_SHA /
 * VITE_APP_* env vars or from `git` during the build.
 *
 * In local dev they fall back to "dev".
 */

declare const __APP_BUILD__: string | undefined
declare const __APP_COMMIT__: string | undefined

export const FRONTEND_BUILD: string =
  typeof __APP_BUILD__ !== 'undefined' && __APP_BUILD__ ? __APP_BUILD__ : 'dev'
export const FRONTEND_COMMIT: string =
  typeof __APP_COMMIT__ !== 'undefined' && __APP_COMMIT__ ? __APP_COMMIT__ : 'dev'
